export default __webpack_public_path__ + "static/empty_background-3d9e0f1a2a966e32fcccca8c8a398e3d.png";